import React from 'react';
import Header from '../../components/common/Header';
import HeroCarousel from '../../components/sections/HeroCarousel';
import Footer from '../../components/common/Footer';
import './Home.module.css';

// Import with direct path to avoid index.js issues
import WelcomeSection from '../../components/sections/WelcomeSection/WelcomeSection';

import { Layout } from 'lucide-react';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <HeroCarousel />
      <WelcomeSection />
      
      {/* Regulatory Disclosure Section */}
      <div style={{
        background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
        padding: '2rem 1rem',
        textAlign: 'center',
        borderTop: '2px solid #16a34a',
        borderBottom: '2px solid #16a34a'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h3 style={{ 
            color: '#16a34a', 
            fontSize: '1.5rem', 
            fontWeight: '600',
            marginBottom: '1rem' 
          }}>
            AMFI Registered Mutual Fund Distributor
          </h3>
          <p style={{ 
            color: '#15803d', 
            fontSize: '1.1rem',
            marginBottom: '0.5rem',
            fontWeight: '500'
          }}>
            ARN-81431 | Valid till: 10 October 2028
          </p>
          <p style={{ 
            color: '#666', 
            fontSize: '0.95rem',
            lineHeight: '1.6',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            WinNest distributes Regular Plans only and earns commission from AMCs. 
            Direct Plans with lower expense ratios are available for direct investment with AMCs. 
            Mutual fund investments are subject to market risks, read all scheme related documents carefully.
          </p>
        </div>
      </div>
   
      <Footer />
    </div>
  );
};
export default Home;